// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__xc16V","header":"Contacts_header__fzVSS","goBack":"Contacts_goBack__5htZ1","container":"Contacts_container__STgzV"};